var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRadar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.625 10.5C11.8321 10.5 12 10.3321 12 10.125V0.375C12 0.167893 11.8321 0 11.625 0H0.375C0.167893 0 0 0.167893 0 0.375V10.125C0 10.3321 0.167893 10.5 0.375 10.5H1.32275L1.32275 9.60136H2.44775V10.5H9.58008V9.60136H10.7051V10.5H11.625ZM1.125 9.375V1.125H10.875V2.2337H7.875C7.25368 2.2337 6.75 2.73738 6.75 3.3587C6.75 3.98002 7.25368 4.4837 7.875 4.4837H10.875V9.375H1.125Z",
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88525 11.9357C2.19591 11.9357 2.44775 11.6838 2.44775 11.3732V10.5H1.32275V11.3732C1.32275 11.6838 1.57459 11.9357 1.88525 11.9357Z",
    fill: "#A0A0A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1426 11.9357C10.4532 11.9357 10.7051 11.6838 10.7051 11.3732V10.5H9.58008V11.3732C9.58008 11.6838 9.83192 11.9357 10.1426 11.9357Z",
    fill: "#A0A0A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7051 9.60136H9.58008V10.5H10.7051V9.60136Z",
    fill: "#A0A0A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44775 9.60136H1.32275L1.32275 10.5H2.44775V9.60136Z",
    fill: "#A0A0A0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRadar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Radar.59731aad1074f9667a5480821429c331.svg";